import React, { Component, Fragment } from "react";
import Select from "react-select";
import PlacesAutocomplete from "react-places-autocomplete";
import {
    sendSingleFieldValueOnBlur,
    check,
    records
} from "../../../services/userDatails";
import { list } from "../../../services/industry";
import AppContext from "../../../contexts/AppContext";
import * as changeCase from "change-case";
import Waiting from "../../utilities/Waiting";
import GoogleLocation from "./../GoogleLocation";

export class Data extends Component {
    state = {
        errors: {},
        byline: "",
        topIndustryExperience: [],
        personalWebsite: "",
        url1: "",
        url2: "",
        url3: "",
        location: "",
        linkedin: "",
        facebook: "",
        twitter: "",
        instagram: "",
        waiting: true,
        isIndustriesSelected: null
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    validateUrl = e => {
        var urlregex = new RegExp(
            "^(http|https|ftp)://([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&amp;%$-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9-]+.)*[a-zA-Z0-9-]+.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(/($|[a-zA-Z0-9.,?'\\+&amp;%$#=~_-]+))*$"
        );
        if (!urlregex.test(e.target.value)) {
            let error = this.state.errors;
            error[e.target.name] = null;

            this.setState({ errors: error });

            e.target.classList.remove("valid");
            e.target.classList.add("not-valid");
            return false;
        } else {
            let error = this.state.errors;
            error[e.target.name] = null;

            this.setState({ errors: error });

            e.target.classList.remove("not-valid");
            e.target.classList.add("valid");
            return true;
        }
    };

    validateNonUrl = e => {
        if (e.target.value === "") {
            e.target.classList.remove("valid");
            e.target.classList.add("not-valid");

            let error = this.state.errors;
            error[e.target.name] = null;

            this.setState({ errors: error });

            return false;
        } else {
            e.target.classList.remove("not-valid");
            e.target.classList.add("valid");

            let error = this.state.errors;
            error[e.target.name] = null;

            this.setState({ errors: error });

            return true;
        }
    };

    handleSelect = selectedOptions => {
        this.setState({ topIndustryExperience: selectedOptions || [] });
    };

    handleSelectBlur = key => {
        setTimeout(() => {
            if (this.state.topIndustryExperience.length > 0) {
                this.setState({ isIndustriesSelected: true });
            } else {
                this.setState({ isIndustriesSelected: false });
            }
        });
        sendSingleFieldValueOnBlur({
            key: key,
            value: this.state[key].map(option => option.id)
        }).then(res => {
            this.context.state.showCodeMessage(
                changeCase.noCase(`"${res.data.key}" has been updated`),
                "success"
            );
        });
    };

    handleNonUrlFieldsBlur = e => {
        if (this.validateNonUrl(e)) {
            sendSingleFieldValueOnBlur({
                key: e.target.name,
                value: this.state[e.target.name]
            }).then(res => {
                this.context.state.showCodeMessage(
                    changeCase.noCase(`"${res.data.key}" has been updated`),
                    "success"
                );
            });
        }
    };

    handleUrlFieldsBlur = e => {
        if (this.validateUrl(e)) {
            sendSingleFieldValueOnBlur({
                key: e.target.name,
                value: this.state[e.target.name]
            }).then(res => {
                this.context.state.showCodeMessage(
                    changeCase.noCase(`"${res.data.key}" has been updated`),
                    "success"
                );
            });
        }
    };

    handleSubmit = e => {
        e.preventDefault();
        check("writer")
            .then(res => {
                this.props.history.push("/writer/dashboard");
            })
            .catch(error => {
                const errors = error.response.data.error;
                let temp = [];
                errors.forEach(err => {
                    for (const key in err) {
                        if (err.hasOwnProperty(key)) {
                            temp[key] = err[key];
                        }
                    }
                });
                this.setState({ errors: temp });
            });
    };
    getIndustry = arrayOfIds => {
        this.state.industries.filter(industry => {
            return arrayOfIds.indexOf(industry.id) >= 0;
        });
    };
    componentDidMount() {
        list()
            .then(res => {
                this.setState({ industries: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        records()
            .then(res => {
                this.setState({ waiting: false });
                for (var key in res.data) {
                    if (key === "topIndustryExperience") {
                        var arrayOfIds = [];
                        if (res.data[key].indexOf(",") >= 0) {
                            arrayOfIds = res.data[key]
                                .split(",")
                                .map(id => parseInt(id, 10));
                        } else {
                            arrayOfIds = [parseInt(res.data[key], 10)];
                        }
                        const initialSelectValue = this.getIndustry(arrayOfIds);
                        this.setState({
                            topIndustryExperience: initialSelectValue
                        });
                    } else {
                        this.setState({
                            [key]: res.data[key]
                        });
                    }
                }
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    handleChangePlaces = location => {
        this.setState({ location });
    };

    handleSelectPlaces = location => {
        this.setState({ location });
        sendSingleFieldValueOnBlur({
            key: "location",
            value: location
        }).then(res => {
            this.context.state.showCodeMessage(
                changeCase.noCase(`"${res.data.key}" has been updated`),
                "success"
            );
        });
    };
    render() {
        return (
            <Fragment>
                <GoogleLocation></GoogleLocation>
                {this.state.waiting === true ? (
                    <Waiting></Waiting>
                ) : (
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-8">
                            <div className="m-login__wrapper-1 m-portlet-full-height">
                                <div className="m-login__wrapper-1-1">
                                    <div className="m-login__contanier">
                                        <form
                                            onSubmit={this.handleSubmit}
                                            id="dataForm"
                                            className="has-validation-callback"
                                        >
                                            <div className="header">
                                                <div className="header-body">
                                                    <h1 className="header-title display-4">
                                                        Final step! Verify your
                                                        experience and identity
                                                    </h1>
                                                </div>
                                            </div>

                                            <div className="m-login__content">
                                                <div className="form-group m-form__group">
                                                    <label htmlFor="byline">
                                                        Byline
                                                    </label>
                                                    <br />
                                                    <span className="form-text text-muted">
                                                        Write in 3rd person.
                                                        Include industries you
                                                        cover, career
                                                        highlights, your
                                                        location, and a fun fact
                                                        about yourself.
                                                    </span>
                                                    <textarea
                                                        value={
                                                            this.state.byline
                                                        }
                                                        row="5"
                                                        maxLength="255"
                                                        className="form-control m-input"
                                                        name="byline"
                                                        id="byline"
                                                        onBlur={
                                                            this
                                                                .handleNonUrlFieldsBlur
                                                        }
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                    ></textarea>
                                                    {this.state.errors
                                                        .byline ? (
                                                        <div className="invalid-feedback">
                                                            The title field is
                                                            required.
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="form-group m-form__group">
                                                    <label htmlFor="topIndustryExperience">
                                                        Top industry experiences
                                                    </label>
                                                    <Select
                                                        className={`${
                                                            this.state
                                                                .isIndustriesSelected ===
                                                            true
                                                                ? "valid"
                                                                : null
                                                        } ${
                                                            this.state
                                                                .isIndustriesSelected ===
                                                            false
                                                                ? "not-valid"
                                                                : null
                                                        }`}
                                                        styles={{
                                                            control: base => ({
                                                                ...base,
                                                                "&:hover": {
                                                                    borderColor:
                                                                        "#1cd2ad",
                                                                    boxShadow:
                                                                        "none"
                                                                },
                                                                "&": {
                                                                    borderColor:
                                                                        "#d2ddec",
                                                                    boxShadow:
                                                                        "none"
                                                                }
                                                            }),
                                                            dropdownIndicator: base => ({
                                                                ...base,
                                                                color: "inherit"
                                                            }),
                                                            singleValue: base => ({
                                                                ...base,
                                                                color: "inherit"
                                                            })
                                                        }}
                                                        onChange={
                                                            this.handleSelect
                                                        }
                                                        onBlur={() =>
                                                            this.handleSelectBlur(
                                                                "topIndustryExperience"
                                                            )
                                                        }
                                                        isMulti={true}
                                                        value={
                                                            this.state
                                                                .topIndustryExperience
                                                        }
                                                        options={
                                                            this.state
                                                                .industries
                                                        }
                                                    ></Select>
                                                </div>
                                                <div className="form-group m-form__group">
                                                    <label htmlFor="personalWebsite">
                                                        Personal website
                                                    </label>
                                                    <input
                                                        value={
                                                            this.state
                                                                .personalWebsite
                                                        }
                                                        placeholder="​https://www.website.com/"
                                                        className="form-control m-input"
                                                        type="text"
                                                        onBlur={
                                                            this
                                                                .handleUrlFieldsBlur
                                                        }
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                        data-validation="url"
                                                        id="personalWebsite"
                                                        name="personalWebsite"
                                                    />
                                                    {this.state.errors
                                                        .personalWebsite ? (
                                                        <div className="invalid-feedback">
                                                            Please write a{" "}
                                                            <strong>
                                                                Valid URL
                                                            </strong>
                                                            !
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <label htmlFor="url3">
                                                    Writing samples
                                                </label>
                                                <p className="text-muted">
                                                    Provide 3 links to bylined
                                                    articles you’ve written.
                                                </p>
                                                <div className="form-group m-form__group">
                                                    <input
                                                        value={this.state.url1}
                                                        placeholder="​https://www.publication.com/your-article-here"
                                                        className="form-control m-input"
                                                        type="text"
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                        onBlur={
                                                            this
                                                                .handleUrlFieldsBlur
                                                        }
                                                        data-validation="url"
                                                        name="url1"
                                                    />
                                                    {this.state.errors.url1 ? (
                                                        <div className="invalid-feedback">
                                                            Please write a{" "}
                                                            <strong>
                                                                Valid URL
                                                            </strong>
                                                            !
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="form-group m-form__group">
                                                    <input
                                                        value={this.state.url2}
                                                        placeholder="https://www.publication.com/your-article-here"
                                                        className="form-control m-input"
                                                        type="text"
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                        onBlur={
                                                            this
                                                                .handleUrlFieldsBlur
                                                        }
                                                        data-validation="url"
                                                        name="url2"
                                                    />
                                                    {this.state.errors.url2 ? (
                                                        <div className="invalid-feedback">
                                                            Please write a{" "}
                                                            <strong>
                                                                Valid URL
                                                            </strong>
                                                            !
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="form-group m-form__group">
                                                    <input
                                                        value={this.state.url3}
                                                        placeholder="​https://www.publication.com/your-article-here"
                                                        className="form-control m-input"
                                                        type="text"
                                                        onChange={
                                                            this.handleChange
                                                        }
                                                        onBlur={
                                                            this
                                                                .handleUrlFieldsBlur
                                                        }
                                                        data-validation="url"
                                                        name="url3"
                                                    />
                                                    {this.state.errors.url3 ? (
                                                        <div className="invalid-feedback">
                                                            Please write a{" "}
                                                            <strong>
                                                                Valid URL
                                                            </strong>
                                                            !
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="form-group m-form__group">
                                                    <label htmlFor="location">
                                                        Location
                                                    </label>
                                                    <br />

                                                    <div className="row">
                                                        <div className="col-12 col-md-12 mb-3">
                                                            {this.context.state
                                                                .gmapsLoaded ===
                                                            true ? (
                                                                <PlacesAutocomplete
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .location
                                                                    }
                                                                    searchOptions={{
                                                                        types: [
                                                                            "(cities)"
                                                                        ],
                                                                        componentRestrictions: {
                                                                            country:
                                                                                "usa"
                                                                        }
                                                                    }}
                                                                    onChange={
                                                                        this
                                                                            .handleChangePlaces
                                                                    }
                                                                    onSelect={
                                                                        this
                                                                            .handleSelectPlaces
                                                                    }
                                                                >
                                                                    {({
                                                                        getInputProps,
                                                                        suggestions,
                                                                        getSuggestionItemProps,
                                                                        loading
                                                                    }) => (
                                                                        <div>
                                                                            <input
                                                                                {...getInputProps(
                                                                                    {
                                                                                        placeholder:
                                                                                            "Search Places ...",
                                                                                        className:
                                                                                            "location-search-input form-control"
                                                                                    }
                                                                                )}
                                                                            />
                                                                            <div className="autocomplete-dropdown-container">
                                                                                {loading && (
                                                                                    <div>
                                                                                        Loading...
                                                                                    </div>
                                                                                )}
                                                                                {suggestions.map(
                                                                                    suggestion => {
                                                                                        const className = suggestion.active
                                                                                            ? "suggestion-item--active"
                                                                                            : "suggestion-item";
                                                                                        // inline style for demonstration purpose
                                                                                        const style = suggestion.active
                                                                                            ? {
                                                                                                  backgroundColor:
                                                                                                      "#fafafa",
                                                                                                  cursor:
                                                                                                      "pointer"
                                                                                              }
                                                                                            : {
                                                                                                  backgroundColor:
                                                                                                      "#ffffff",
                                                                                                  cursor:
                                                                                                      "pointer"
                                                                                              };
                                                                                        return (
                                                                                            <div
                                                                                                {...getSuggestionItemProps(
                                                                                                    suggestion,
                                                                                                    {
                                                                                                        className,
                                                                                                        style
                                                                                                    }
                                                                                                )}
                                                                                            >
                                                                                                <span>
                                                                                                    {
                                                                                                        suggestion.description
                                                                                                    }
                                                                                                </span>
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </PlacesAutocomplete>
                                                            ) : null}

                                                            {this.state.errors
                                                                .location ? (
                                                                <div className="invalid-feedback">
                                                                    The location
                                                                    field is
                                                                    required.
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-12 col-md-12">
                                                        <div className="">
                                                            <div className="form-group m-form__group">
                                                                <label>
                                                                    Social
                                                                    verification
                                                                </label>
                                                                <p>
                                                                    In order to
                                                                    verify your
                                                                    identity,
                                                                    please
                                                                    connect to
                                                                    at least one
                                                                    of the below
                                                                    social
                                                                    networks.
                                                                </p>

                                                                <div className="row m-0">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <p className="mb-0 social-icons">
                                                                            <i className="fe fe-linkedin"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-12 col-md-10">
                                                                        <input
                                                                            value={
                                                                                this
                                                                                    .state
                                                                                    .linkedin
                                                                            }
                                                                            onChange={
                                                                                this
                                                                                    .handleChange
                                                                            }
                                                                            onBlur={
                                                                                this
                                                                                    .handleUrlFieldsBlur
                                                                            }
                                                                            placeholder="www.linkedin.com/your.name"
                                                                            name="linkedin"
                                                                            type="text"
                                                                            className="form-control"
                                                                        />
                                                                        {this
                                                                            .state
                                                                            .errors
                                                                            .linkedin ? (
                                                                            <div className="invalid-feedback">
                                                                                Please
                                                                                write
                                                                                a{" "}
                                                                                <strong>
                                                                                    Valid
                                                                                    URL
                                                                                </strong>

                                                                                !
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group m-form__group">
                                                                <div className="row m-0">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <p className="mb-0 social-icons">
                                                                            <i className="fe fe-facebook"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-12 col-md-10">
                                                                        <input
                                                                            value={
                                                                                this
                                                                                    .state
                                                                                    .facebook
                                                                            }
                                                                            onChange={
                                                                                this
                                                                                    .handleChange
                                                                            }
                                                                            onBlur={
                                                                                this
                                                                                    .handleUrlFieldsBlur
                                                                            }
                                                                            placeholder="www.facebook.com/your.name"
                                                                            name="facebook"
                                                                            type="text"
                                                                            className="form-control"
                                                                        />
                                                                        {this
                                                                            .state
                                                                            .errors
                                                                            .facebook ? (
                                                                            <div className="invalid-feedback">
                                                                                Please
                                                                                write
                                                                                a{" "}
                                                                                <strong>
                                                                                    Valid
                                                                                    URL
                                                                                </strong>

                                                                                !
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group m-form__group">
                                                                <div className="row m-0">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <p className="mb-0 social-icons">
                                                                            <i className="fe fe-twitter"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-12 col-md-10">
                                                                        <input
                                                                            value={
                                                                                this
                                                                                    .state
                                                                                    .twitter
                                                                            }
                                                                            placeholder="www.twitter.com/username"
                                                                            onChange={
                                                                                this
                                                                                    .handleChange
                                                                            }
                                                                            onBlur={
                                                                                this
                                                                                    .handleUrlFieldsBlur
                                                                            }
                                                                            name="twitter"
                                                                            type="text"
                                                                            className="form-control"
                                                                        />
                                                                        {this
                                                                            .state
                                                                            .errors
                                                                            .twitter ? (
                                                                            <div className="invalid-feedback">
                                                                                Please
                                                                                write
                                                                                a{" "}
                                                                                <strong>
                                                                                    Valid
                                                                                    URL
                                                                                </strong>

                                                                                !
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group m-form__group">
                                                                <div className="row m-0">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <p className="mb-0 social-icons">
                                                                            <i className="fe fe-instagram"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-12 col-md-10">
                                                                        <input
                                                                            value={
                                                                                this
                                                                                    .state
                                                                                    .instagram
                                                                            }
                                                                            placeholder="www.instagram.com/username"
                                                                            onChange={
                                                                                this
                                                                                    .handleChange
                                                                            }
                                                                            onBlur={
                                                                                this
                                                                                    .handleUrlFieldsBlur
                                                                            }
                                                                            name="instagram"
                                                                            type="text"
                                                                            className="form-control"
                                                                        />
                                                                        {this
                                                                            .state
                                                                            .errors
                                                                            .instagram ? (
                                                                            <div className="invalid-feedback">
                                                                                Please
                                                                                write
                                                                                a{" "}
                                                                                <strong>
                                                                                    Valid
                                                                                    URL
                                                                                </strong>

                                                                                !
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                type="submit"
                                                className="btn btn-block btn-primary mb-3"
                                                onSubmit={this.handleSubmit}
                                            >
                                                Submit &amp; Continue
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

Data.contextType = AppContext;
export default Data;



// WEBPACK FOOTER //
// ./src/components/auth/register/Data.js